// import React, { useState } from 'react';
// import {
//     Grid, Card, CardHeader, CardContent, Divider,
//     TextField, Button, IconButton, Typography, makeStyles
// } from '@material-ui/core';
// import AddCircleIcon from '@material-ui/icons/AddCircle';
// import DeleteIcon from '@material-ui/icons/Delete';
// import useAgentCreate from 'api/useAgentCreate.js';
// import notifySuccess from 'utils/Toast';
// import routes from 'routes';
// import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

// const useStyles = makeStyles((theme) => ({
//     root: {
//         padding: theme.spacing(4)
//     },
//     inputRow: {
//         display: 'flex',
//         alignItems: 'center',
//         marginBottom: theme.spacing(2),
//     },
//     saveButton: {
//         marginTop: theme.spacing(2),
//         backgroundColor: theme.palette.secondary.main,
//         color: 'white',
//         '&:hover': {
//             backgroundColor: theme.palette.secondary.dark,
//         }
//     },
//     errorText: {
//         color: theme.palette.error.main,
//         fontSize: '0.75rem',
//         marginTop: theme.spacing(-1),
//         marginBottom: theme.spacing(1),
//     }
// }));

// function UserAgentForm() {
//     const classes = useStyles();
//     const [items, setItems] = useState([{userAgent:''}]);
//     const [errors, setErrors] = useState({});
//     const { saveAgents, isLoading } = useAgentCreate();
//     let history = useHistory();

//     // Add a new empty input field
//     const handleAddField = () => {
//         setItems([...items, {userAgent:''}]);
//     };

//     // Remove a specific input field
//     const handleRemoveField = (index) => {
//         const newList = items.filter((_, i) => i !== index);
//         setItems(newList);
//         // Clear errors for that field
//         const newErrors = { ...errors };
//         delete newErrors[index];
//         setErrors(newErrors);
//     };

//     // Update value as user types
//     const handleChange = (index, value) => {
//         const newList = [...items];
//         newList[index] = {userAgent:value};
//         setItems(newList);
//     };

//     // Check for duplicates when user leaves the input field
//     const handleBlur = (index) => {
//         const value = items[index].userAgent.trim();
//         if (!value) return;

//         const isDuplicate = items.some((item, i) =>
//             item.userAgent.trim().toLowerCase() === value.toLowerCase() && i !== index
//         );

//         setErrors(prev => ({
//             ...prev,
//             [index]: isDuplicate ? 'This value already exists' : null
//         }));
//     };

//    const handleSave = async() => {
//     const hasErrors = Object.values(errors).some(error => error !== null);

//     // Filter out rows where userAgent is empty or just whitespace
//     const nonEmptyItems = items.filter(item => item.userAgent.trim() !== '');

//     if (!hasErrors) {
//         // Remove duplicates based on the 'userAgent' property
//         const uniqueData = nonEmptyItems.filter((item, index, self) =>
//             index === self.findIndex((t) => (
//                 t.userAgent.trim().toLowerCase() === item.userAgent.trim().toLowerCase()
//             ))
//         );

//         console.log("Saving unique items payload:", uniqueData);
//           if (uniqueData.length > 0) {
//             // 2. Call the trigger function manually
//           const result =  await saveAgents(uniqueData);
//           if (result.status === 200){
//             notifySuccess("User Agent is added successfully.");
//              history.push(`${routes.userAgent.path}`);
//           }

//           console.log(result,"result result")
//     }
// };
//    }
//     return (
//         <div className={classes.root}>
//             <Grid container spacing={4}>
//                 <Grid item xs={12} md={8} lg={6}>
//                     <Card>
//                         <CardHeader
//                             title="User Agents"
//                             action={
//                                 <IconButton color="primary" onClick={handleAddField}>
//                                     <AddCircleIcon />
//                                 </IconButton>
//                             }
//                         />
//                         <Divider />
//                         <CardContent>
//                             {items.map((item, index) => (
//                                 <div key={index}>
//                                     <div className={classes.inputRow}>
//                                         <TextField
//                                             fullWidth
//                                             variant="outlined"
//                                             label={`Enter Agent ${index + 1} details`}
//                                             value={item.userAgent}
//                                             error={!!errors[index]}
//                                             onChange={(e) => handleChange(index, e.target.value)}
//                                             onBlur={() => handleBlur(index)}
//                                         />
//                                         {items.length > 1 && (
//                                             <IconButton onClick={() => handleRemoveField(index)} color="secondary">
//                                                 <DeleteIcon />
//                                             </IconButton>
//                                         )}
//                                     </div>
//                                     {errors[index] && (
//                                         <Typography className={classes.errorText}>
//                                             {errors[index]}
//                                         </Typography>
//                                     )}
//                                 </div>
//                             ))}

//                             <Button
//                                 variant="contained"
//                                 className={classes.saveButton}
//                                 onClick={handleSave}
//                                 disabled={Object.values(errors).some(e => e !== null)}
//                             >
//                                 Save Agents
//                             </Button>
//                         </CardContent>
//                     </Card>
//                 </Grid>
//             </Grid>
//         </div>
//     );
// }

// export default UserAgentForm;

import React, { useState, useMemo } from "react";
import {
  Grid,
  Card,
  CardHeader,
  CardContent,
  Divider,
  TextField,
  Button,
  Typography,
  makeStyles,
  Chip,
} from "@material-ui/core";
import useAgentCreate from "api/useAgentCreate.js";
import notifySuccess from "utils/Toast";
import routes from "routes";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import UrlManagerPopup from "./UrlManagerPopup";

const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(4) },
  dateField: {
    marginTop: theme.spacing(3),
    maxWidth: 300, // Keeps the date picker from being too wide
  },
  saveButton: {
    marginTop: theme.spacing(2),
    backgroundColor: theme.palette.secondary.main,
    color: "white",
    "&:hover": { backgroundColor: theme.palette.secondary.dark },
  },
  footer: {
    marginTop: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  counterChip: {
    fontWeight: "bold",
    backgroundColor: theme.palette.info.light,
    color: theme.palette.info.contrastText,
  },
}));

function UserAgentForm() {
  const classes = useStyles();
  const [rawInput, setRawInput] = useState("");
  const { saveAgents, isLoading } = useAgentCreate();

  const [updateDate, setUpdateDate] = useState(
    new Date().toISOString().split("T")[0],
  );

  let history = useHistory();

  // Live Validation Logic: Extracts unique agents from the text
  const processedAgents = useMemo(() => {
    if (!rawInput.trim()) return [];

    const list = rawInput
      .split(/[\n]/)
      .map((item) => item.trim())
      .filter((item) => item !== "");

    return [...new Set(list)]; // Deduplicate
  }, [rawInput]);

  const handleSave = async () => {
    if (processedAgents.length === 0) return;

    // Format into payload array
    const payload = processedAgents.map((agent) => ({
      userAgent: agent,
      updateUADateByBrowser: updateDate,
    }));

    try {
      const result = await saveAgents(payload);
      if (result.status === 200) {
        notifySuccess(
          `${processedAgents.length} User Agents added successfully.`,
        );
        history.push(`${routes.userAgent.path}`);
      }
    } catch (error) {
      console.error("Save failed:", error);
    }
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={10} lg={8}>
          <Card>
            <CardHeader
              title="Add User Agents"
              subheader="Paste your list below (comma or newline separated)"
             
            />
            <Divider />
            <CardContent>
              <TextField
                fullWidth
                multiline
                minRows={10}
                variant="outlined"
                placeholder="Paste user agents here..."
                value={rawInput}
                onChange={(e) => setRawInput(e.target.value)}
              />

              <TextField
                label="Last Updated Date of Agents"
                type="date"
                variant="outlined"
                className={classes.dateField}
                value={updateDate}
                onChange={(e) => setUpdateDate(e.target.value)}
                InputLabelProps={{ shrink: true }} // Required for type="date"
                fullWidth
              />

              <div className={classes.footer}>
                <div>
                  {processedAgents.length > 0 && (
                    <Chip
                      label={`${processedAgents.length} Unique Agents Detected`}
                      className={classes.counterChip}
                    />
                  )}
                </div>

                <Button
                  variant="contained"
                  className={classes.saveButton}
                  onClick={handleSave}
                  disabled={isLoading || processedAgents.length === 0}
                >
                  {isLoading
                    ? "Saving..."
                    : `Save ${processedAgents.length} Agents`}
                </Button>
              </div>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
}

export default UserAgentForm;
